import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        {/* <p align="center">
          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-barrowcleft.webp"
            alt="Barrowcleft"
          />
        </p> */}

        <table class="district-table">
          <tbody>
            <tr>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-barrowcleft"
                      className="district-link"
                    >
                      Barrowcleft
                    </Link>
                  </strong>{" "}
                  [rural]
                </p>
                <p>
                  Dusty rural edge of the city: proud farming clans, wagon
                  roads, and suspicious country folk inside the lightning
                  barrier.
                </p>
              </td>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-docks"
                      className="district-link"
                    >
                      The Docks
                    </Link>
                  </strong>{" "}
                  [rough waterfront]
                </p>
                <p>
                  Sailors, warehouses, rough taverns, fists, cargo, and trouble
                  coming in with every tide.
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-brightstone"
                      className="district-link"
                    >
                      Brightstone
                    </Link>
                  </strong>{" "}
                  [rich]
                </p>
                <p>
                  Old money, noble estates, luxury shops, and the polished
                  cruelty of Doskvol’s elite.
                </p>
              </td>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-dunslough"
                      className="district-link"
                    >
                      Dunslough
                    </Link>
                  </strong>{" "}
                  [prison, desperate]
                </p>
                <p>
                  Prison-shadowed wasteland of labor camps, mud, and the city’s
                  abandoned poor.
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-charhollow"
                      className="district-link"
                    >
                      Charhollow
                    </Link>
                  </strong>{" "}
                  [poor]
                </p>
                <p>
                  Crowded working-class neighborhood of tenements, cook-fires,
                  refugees, and hard-used streets.
                </p>
              </td>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-nightmarket"
                      className="district-link"
                    >
                      Nightmarket
                    </Link>
                  </strong>{" "}
                  [trade]
                </p>
                <p>
                  Rail-fed trade hub for exotic imports, oddities, and all the
                  illicit commerce that hides among them.
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-charterhall"
                      className="district-link"
                    >
                      Charterhall
                    </Link>
                  </strong>{" "}
                  [official]
                </p>
                <p>
                  Government, banks, archives, and university life: civic power
                  with paperwork, fences, and watchful eyes.
                </p>
              </td>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-silkshore"
                      className="district-link"
                    >
                      Silkshore
                    </Link>
                  </strong>{" "}
                  [vice]
                </p>
                <p>
                  Vice, pleasure, art, and performance: the red-lamp district
                  where beauty and exploitation share a wall.
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-coalridge"
                      className="district-link"
                    >
                      Coalridge
                    </Link>
                  </strong>{" "}
                  [industrial]
                </p>
                <p>
                  Smoke, factories, labor unrest, and the brutal industrial
                  heart of the city.
                </p>
              </td>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-six-towers"
                      className="district-link"
                    >
                      Six Towers
                    </Link>
                  </strong>{" "}
                  [decayed old wealth]
                </p>
                <p>
                  Faded grandeur: a once-rich district now decaying into
                  haunted, aristocratic rot.
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-crowsfoot"
                      className="district-link"
                    >
                      Crow’s Foot
                    </Link>
                  </strong>{" "}
                  — [gangland]
                </p>
                <p>
                  Tight, vertical gang territory where every alley feels claimed
                  and every truce feels temporary.
                </p>
              </td>
              <td>
                <p>
                  <strong>
                    <Link
                      to="/blades-in-the-dark-campaign-districts-whitecrown"
                      className="district-link"
                    >
                      Whitecrown
                    </Link>
                  </strong>{" "}
                  — [ruling-class power]
                </p>
                <p>
                  Monumental estates, old institutions, and the seat of official
                  power looking down on the rest of the city.
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClassesCore = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign"
                    >
                      Introduction
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <img
                src={sectionDivider}
                style={{ maxHeight: "169px" }}
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <a name="pageTop" href="#pageTop">
                    {" "}
                  </a>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClassesCore;
